import styled from 'styled-components'

import Box from 'app/components/design-system-components/Box'

const Flex = styled(Box)({
  display: 'flex',
})

export default Flex
